import { mapGetters } from 'vuex';

export const markingSso = {
	computed: {
		...mapGetters(['connected']),
	},
	methods: {
		marketingUrl(path = '', utmMedium = 'WordPressPlugin') {
			if (this.connected) {
				return this.$urls.marketingSso(path, utmMedium);
			}

			let url = 0 === path.indexOf('http') ? path : this.$urls.marketing(`${path ? path + '/' : ''}`);

			return this.$urls.utmLink(url, { utm_medium: utmMedium });
		},
	},
};
